/**
 * Reusable filters bottom-sheet: backdrop + sheet, title "Фильтры", close button.
 * Content (filter fields + Apply/Reset) passed as children.
 * Использует BottomSheetModal для плавной анимации.
 */
import { BottomSheetModal } from "./BottomSheetModal.jsx";

export function FiltersModal({ open, onClose, title = "Фильтры", children }) {
  return (
    <BottomSheetModal open={open} onClose={onClose} title={title}>
      {children}
    </BottomSheetModal>
  );
}
